import { httpApi } from 'core/httpApi';

export type IGetLanguagesResponse = Array<{ name: string; code: string; count: number }>;

export const getStoryLanguages = async () =>
    httpApi.v2.get<IGetLanguagesResponse, IGetLanguagesResponse>(`languages`);
